module.exports = __webpack_public_path__ + "img/logo-icon.349df8e0.png";